export enum InclinationTowardsLight {
  SEEK = 'seek',
  AVOID = 'avoid'
}
